module.exports = JSON.parse('{"Hide":"隐藏","Show":"显示","Rename":"重命名","Duplicate":"复制","Delete":"删除","Change Color":"更改颜色","Lock":"锁定","Unlock":"解锁"}')